import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Components/Home";
import Register from "./Components/Register";
import Account from "./Components/Account";
import Employees from "./Components/Employees";
import Tasks from "./Components/Tasks";
import DeletedTasks from "./Components/DeletedTasks";
import EditTask from "./Components/EditTask";
// BookingRequest component is now integrated into Tasks component
// import BookingRequest from "./Components/BookingRequest";
import Calendar from "./Components/Calendar";
import LeaveRequest from "./Components/LeaveRequest";
import Notification from "./Components/Notifications";
import UpdateEmployee from "./Components/UpdateEmployee";
import AddEmployee from "./Components/AddEmployee";
import Chat from "./Components/Chat";
import GenerateInvoice from "./Components/GenerateInvoice";
import InvoiceHistory from './Components/InvoiceHistory';
import DisputesPage from "./Components/DisputesPage";
import DisputeDetail from "./Components/DisputeDetail";
import CreateTask from "./Components/CreateTask";
function App() {
  
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Home route */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/account" element={<Account />} />
          <Route path="/employees" element={<Employees />} />
          <Route
            path="/employees/update-employee/:id"
            element={<UpdateEmployee />}
          />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/tasks/deleted" element={<DeletedTasks />} />
          <Route path="/tasks/edit-task/:taskId" element={<EditTask />} />
          <Route path="/tasks/chat/:taskId" element={<Chat />} />
          <Route path="/tasks/generate-invoice/:taskId" element={<GenerateInvoice />} />
          <Route path="/tasks/invoice-history/:taskId" element={<InvoiceHistory />} /> {/* New route for Invoice History */}
          {/* Booking Requests routes now redirect to Tasks page with Booking Requests tab */}
          <Route path="/booking-requests" element={<Tasks />} />
          <Route path="/booking-requests/:taskId" element={<Chat />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/request-vacation-sick" element={<LeaveRequest />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/add-employee" element={<AddEmployee />} />
          <Route path="/disputes" element={<DisputesPage />} />
          <Route path="/disputes/:id" element={<DisputeDetail />} />
          <Route path="/tasks/create" element={<CreateTask />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
